import { useContext } from "react";

import { InternalOrganizationContext } from "../context/OrganizationContext";
import { IOrganizationContext } from "../types/organization/IOrganizationContext";

/**
 * Convenience hook for consuming the OrganizationContext. Throws when
 * used outside an OrganizationProvider so misuse is caught immediately
 * during development.
 *
 * @returns The current organization context value.
 */
export function useOrganization(): IOrganizationContext {
  const context = useContext(InternalOrganizationContext);
  if (!context) {
    throw new Error("useOrganization must be used within an OrganizationProvider");
  }
  return context;
}
